import { useEffect } from 'react';
import styled from 'styled-components';
import { Screen } from '../../styles';

const transferCharges = [
  {
    type: 'Abbey to Abbey Transfer',
    base: '₦0.00',
    vat: '₦0.00',
    total: 'FREE',
  },
  {
    type: 'Transfer below ₦5,000',
    base: '₦10.00',
    vat: '₦0.75',
    total: '₦10.75',
  },
  {
    type: 'Transfer from ₦5,001 – ₦50,000',
    base: '₦25.00',
    vat: '₦1.88',
    total: '₦26.88',
  },
  {
    type: 'Transfer above ₦50,000',
    base: '₦50.00',
    vat: '₦3.75',
    total: '₦53.75',
  },
];

const TransactionCharges = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box>
      <Section className='hero'></Section>
      <Container>
        <Header>Transaction Charges</Header>
        <Paragraph>
          At Abbey Bank, we believe in keeping our charges clear and
          transparent. Please find below the applicable fees for transfers
          and selected digital banking services.
        </Paragraph>

        <SubHeader>Transfer Charges</SubHeader>
        <TableWrapper>
          <Table>
            <thead>
              <tr>
                <th>Transaction Type</th>
                <th>Base Fee</th>
                <th>VAT (7.5%)</th>
                <th>Total Fee</th>
              </tr>
            </thead>
            <tbody>
              {transferCharges.map((row, index) => (
                <tr key={index}>
                  <td>{row.type}</td>
                  <td>{row.base}</td>
                  <td>{row.vat}</td>
                  <td className={row.total === 'FREE' ? 'free' : ''}>
                    {row.total}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </TableWrapper>

        <Note>
          <strong>Note:</strong> A ₦50 Electronic Money Transfer Levy (EMTL)
          applies to qualifying electronic transfers/inflows of ₦10,000 or
          more, where applicable.
        </Note>

        <SubHeader>Other Digital Banking Charges</SubHeader>

        <BlockHeader>Bill Payments</BlockHeader>
        <Paragraph className='block'>
          Electricity, cable TV and other utility/service bill payments
          attract a flat fee of <strong>₦100 per transaction</strong>.
        </Paragraph>

        <BlockHeader>Airtime &amp; Data</BlockHeader>
        <Paragraph className='block'>
          Airtime and data purchases are <strong>FREE</strong>.
        </Paragraph>

        <Disclaimer>
          All charges are subject to applicable regulatory requirements and
          may be reviewed from time to time.
        </Disclaimer>
      </Container>
    </Box>
  );
};

const Box = styled.div`
  width: 100%;
  min-height: 100vh;
`;

const Section = styled.div`
  width: 100%;
  &.hero {
    min-height: 20vh;
    ${Screen.mediumpc`
    min-height: 10vh!important;
    `}
    ${Screen.smallpc`
    min-height: 10vh!important;
    `}
    ${Screen.tablet`
    min-height: 10vh!important;
    `}
    ${Screen.mediumPhone`
    min-height: 5vh!important;
    margin-top: 5rem!important;
    `}
    ${Screen.phone`
    min-height: 5vh!important;
    margin-top: 5rem!important;
    `}
    ${Screen.smallPhone`
    min-height: 5vh!important;
    margin-top: 5rem!important;
    `}
  }
`;

const Container = styled.div`
  width: 70%;
  margin: 2rem auto 5rem;
  ${Screen.miniLargeScreen`
  width: 85%;
  `}
  ${Screen.pad`
  width: 80%;
  `}
  ${Screen.mediumpc`
  width: 80%;
  `}
  ${Screen.smallpc`
  width: 85%;
  `}
  ${Screen.tablet`
  width: 85%;
  `}
  ${Screen.mediumPhone`
  width: 90%;
  `}
  ${Screen.phone`
  width: 90%;
  `}
  ${Screen.smallPhone`
  width: 90%;
  `}
`;

const Header = styled.h1`
  font-size: 2.2rem;
  color: #002668;
  text-align: center;
  margin-bottom: 1.5rem;
  ${Screen.tablet`
  font-size: 1.8rem;
  `}
  ${Screen.phone`
  font-size: 1.5rem;
  `}
`;

const SubHeader = styled.h2`
  font-size: 1.4rem;
  color: #002668;
  margin: 2.5rem 0 1rem;
  ${Screen.phone`
  font-size: 1.2rem;
  `}
`;

const BlockHeader = styled.h3`
  font-size: 1.15rem;
  color: #002668;
  margin: 1.5rem 0 0.5rem;
`;

const Paragraph = styled.p`
  font-size: 1.05rem;
  line-height: 1.6;
  color: #333;

  &.block {
    margin-bottom: 0.5rem;
  }

  ${Screen.phone`
  font-size: .95rem;
  `}
`;

const TableWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 0.5rem;

  th,
  td {
    border: 1px solid #ddd;
    padding: 0.75rem 1rem;
    text-align: left;
    font-size: 1rem;
    white-space: nowrap;
  }

  th {
    background-color: #002668;
    color: #fff;
    font-weight: 600;
  }

  tr:nth-child(even) {
    background-color: #f7f7f7;
  }

  td.free {
    color: #0a8a3a;
    font-weight: 700;
  }

  ${Screen.phone`
  th, td {
    font-size: .85rem;
    padding: .5rem .75rem;
  }
  `}
`;

const Note = styled.p`
  font-size: 0.95rem;
  color: #555;
  margin-top: 1rem;
  line-height: 1.6;
`;

const Disclaimer = styled.p`
  font-size: 0.9rem;
  color: #777;
  margin-top: 2.5rem;
  font-style: italic;
`;

export default TransactionCharges;
